export enum LocationFilterType {
	COUNTRY = 'CountryFilter',
	CONTINENT = 'ContinentFilter',
}
